// frontend/src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Blog from './pages/Blog';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import BlogPost from './pages/BlogPost';
import Portfolio from './pages/Portfolio';
import PortfolioMember from './pages/PortfolioMember';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import './App.css';

// متا تگ‌های پیشفرض برای کل سایت
const defaultMetaTags = {
  title: 'شرکت صنعتی BusinessPro - تولید محصولات صنعتی با کیفیت',
  description: 'شرکت صنعتی BusinessPro با ۲۰ سال سابقه در تولید محصولات صنعتی با کیفیت. ارائه خدمات تخصصی و پشتیبانی حرفه‌ای.',
  keywords: 'شرکت صنعتی, محصولات صنعتی, BusinessPro, تولید, صنعت',
  image: '/static/images/og-default.jpg',
  canonical: 'http://localhost:3000',
  type: 'website',
};

function App() {
  return (
    
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:slug" element={<ProductDetail />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/portfolio/members/:id" element={<PortfolioMember />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
